/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

import { createAction } from '../app/createAction';
import { SET_DENSITY_LIST_VIEW } from './densityConstants';
import { IDensityListViewAction, ISetDensityListViewPayload } from './densityTypes';

export const setDensityListView = (payload: ISetDensityListViewPayload): IDensityListViewAction =>
    createAction(SET_DENSITY_LIST_VIEW, payload);
